export const getUserClaimableRewards = async (
  cohortContract,
  user,
  tokenId
) => {
  const trx = await cohortContract.getUserClaimableRewards(user, tokenId);
  return trx;
};
// potentially this is accruedReward

export const getRemainingTokens = async (cohortContract, tokenId) => {
  const trx = await cohortContract.getRemainingTokens(tokenId);
  return trx;
};

export const getUserDeposited = async (cohortContract, user) => {
  const trx = await cohortContract.supplyAmount(user);
  return trx;
};

export const getRewardSpeed = async (cohortContract, tokenId) => {
  const trx = await cohortContract.rewardSpeeds(tokenId);
  return trx;
};

export const getAllDeposited = async (cohortContract) => {
  const trx = await cohortContract.totalSupplies();
  return trx;
};

export const getUserShare = async (cohortContract, user) => {
  const trx = await cohortContract.getUserDepositedFraction(user);
  return trx;
};

export const getRate = async (cohortContract) => {
  const trx = await cohortContract.stakedTokenYearlyReturn();
  return trx;
};

export const deposit = async (cohortContract, amount) => {
  const trx = await cohortContract.deposit(amount);
  return await trx.wait();
};

export const withdraw = async (cohortContract, amount) => {
  const trx = await cohortContract.withdraw(amount);
  return await trx.wait();
};

export const claim = async (cohortContract) => {
  const trx = await cohortContract.claimRewards();
  return await trx.wait();
};

export const withdrawAll = async (cohortContract) => {
  const trx = await cohortContract.exit();
  return await trx.wait();
};

export const getTokens = async (
  distributionContract,
  id,
  proof,
  recipientAddress,
  amount
) => {
  const trx = await distributionContract.getTokens(
    id,
    proof,
    recipientAddress,
    amount
  );

  return await trx.wait();
};

export const getTokensFromMultiple = async (
  distributionContract,
  ids,
  proofs,
  recipientAddress,
  amounts
) => {
  const trx = await distributionContract.getTokensFromMultiple(
    ids,
    proofs,
    recipientAddress,
    amounts
  );

  return await trx.wait();
};

export const spentERC20 = async (
  distributionContract,
  id,
  recipientAddress
) => {
  return await distributionContract.checkCollected(id, recipientAddress);
};
